export default "__VITE_ASSET__CiiZYMCx__"